import { render, staticRenderFns } from "./mockCertifySelect.vue?vue&type=template&id=b05d0e62"
import script from "./mockCertifySelect.vue?vue&type=script&lang=js"
export * from "./mockCertifySelect.vue?vue&type=script&lang=js"
import style0 from "./mockCertifySelect.vue?vue&type=style&index=0&id=b05d0e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports